import type { Action } from 'redux';
import { MaintenanceReminder } from 'fleet-data-model';
import type { MachineApiResponseData } from '~/api/responseTypes/machine-api-response-data';
import type { AssetListItem } from '~/data/AssetListItem/AssetListItem';
import type { ActionWithPayload, RequestSagaAction } from '~/types/actions.types';
import AssetMapAndDetailsConstants from '~/domain/asset-details-common/components/AssetMapAndDetails/constants';

export const setAssetDetails = (asset: AssetListItem) => ({
  type: AssetMapAndDetailsConstants.SET_ASSET,
  payload: {
    asset,
  },
});

export const updateMaintenanceReminder = (iprId: string, reminder: MaintenanceReminder) => ({
  type: AssetMapAndDetailsConstants.UPDATE_MAINTENANCE_REMINDER,
  payload: {
    iprId,
    reminder,
  },
});

export const setOutdated = (isOutdated) => ({
  type: AssetMapAndDetailsConstants.SET_OUTDATED,
  payload: { isOutdated },
});

export const unsetAsset = (): UnsetAssetType => ({
  type: AssetMapAndDetailsConstants.UNSET_ASSET,
});

export const getAssetDetails = (assetId: AssetId, limited: boolean) => ({
  type: AssetMapAndDetailsConstants.GET_ASSET_DETAILS,
  payload: {
    assetId,
    limited,
  },
});

type SetAssetDetailsType = ActionWithPayload<
  AssetMapAndDetailsConstants.SET_ASSET,
  { asset: AssetListItem }
>;

type UnsetAssetType = Action<AssetMapAndDetailsConstants.UNSET_ASSET>;

type UpdateMaintenanceReminderType = ActionWithPayload<
  AssetMapAndDetailsConstants.UPDATE_MAINTENANCE_REMINDER,
  { iprId: string; reminder: MaintenanceReminder }
>;

type SetOutdatedType = ActionWithPayload<
  AssetMapAndDetailsConstants.SET_OUTDATED,
  { isOutdated: boolean }
>;

type GetAssetDetailsType = RequestSagaAction<
  AssetMapAndDetailsConstants.GET_ASSET_DETAILS_REQUEST,
  AssetMapAndDetailsConstants.GET_ASSET_DETAILS_SUCCESS,
  AssetMapAndDetailsConstants.GET_ASSET_DETAILS_FAILURE,
  { assetId: AssetId; limited?: boolean },
  MachineApiResponseData
>;

export type AssetMapAndDetailsContainerActionTypes =
  | SetAssetDetailsType
  | SetOutdatedType
  | UpdateMaintenanceReminderType
  | GetAssetDetailsType
  | UnsetAssetType;
